const CHICAGO = "America/Chicago";

function chicagoCalendarYearMonth(value: Date): { year: number; month: number } | null {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: CHICAGO,
    year: "numeric",
    month: "numeric",
  }).formatToParts(value);
  const year = Number(parts.find((part) => part.type === "year")?.value);
  const month = Number(parts.find((part) => part.type === "month")?.value);
  if (!Number.isFinite(year) || !Number.isFinite(month)) {
    return null;
  }
  return { year, month };
}

/** GIPI Megaventory created instant, compared as an America/Chicago calendar month. */
export function gipiCreatedInCurrentCalendarMonth(
  createdAt: string | null | undefined,
  now: Date = new Date(),
): boolean {
  if (createdAt == null || createdAt.trim() === "") {
    return false;
  }
  const created = new Date(createdAt);
  if (Number.isNaN(created.getTime())) {
    return false;
  }
  const createdMonth = chicagoCalendarYearMonth(created);
  const nowMonth = chicagoCalendarYearMonth(now);
  if (createdMonth == null || nowMonth == null) {
    return false;
  }
  return createdMonth.year === nowMonth.year && createdMonth.month === nowMonth.month;
}
